import { cloneDeep } from "lodash";
import getMarketplaceMVTMetadata from "@src/template/helpers/getMarketplaceMVTMetadata";
import {
  CATEGORIES_LABEL,
  CLOTHING_LABEL,
  DISCOVER_MORE_LABEL,
  MARKETPLACE_LABEL,
  CTAS_LABEL,
  SHOP_BY_PRODUCT_LABEL
} from "./constants";

const setMarketplaceMVTMutationFlag = nav => {
  nav.marketplaceMVTMutated = true;
};

const handleAddMarketplaceLink = async (navData, platform) => {
  const {
    marketplaceMVTDesktopBucket,
    marketplaceMVTMobileBucket
  } = await getMarketplaceMVTMetadata();

  if (
    marketplaceMVTMobileBucket === "default" &&
    marketplaceMVTDesktopBucket === "default"
  ) {
    return navData;
  }

  const isUserV2BucketDesktop = marketplaceMVTDesktopBucket === "v2";
  const isUserV2BucketMobile = marketplaceMVTMobileBucket === "v2";

  setMarketplaceMVTMutationFlag(navData);

  const navDataWithMarketplaceLink = cloneDeep(navData);
  const marketplaceNavigationShouldBeAdded =
    (isUserV2BucketMobile && platform === "mobile") ||
    (isUserV2BucketDesktop && platform === "desktop");

  navDataWithMarketplaceLink.tree.forEach(gender => {
    const clothingCategory = gender.items
      .find(({ label }) => label.toLowerCase() === CATEGORIES_LABEL)
      .items.find(({ label }) => label.toLowerCase() === CLOTHING_LABEL);

    clothingCategory.items &&
      marketplaceNavigationShouldBeAdded &&
      addMarketplaceLinkItem(
        clothingCategory.items,
        isUserV2BucketDesktop,
        isUserV2BucketMobile
      );

    const marketplaceNavLinks = gender.items
      .find(({ label }) => label.toLowerCase() === DISCOVER_MORE_LABEL)
      .items.find(({ label }) => label.toLowerCase() === MARKETPLACE_LABEL);

    const marketplaceCTAs = marketplaceNavLinks.items.find(
      ({ label }) => label.toLowerCase() === CTAS_LABEL
    );

    marketplaceCTAs.items.length &&
      addMarketplaceMVTFlag(
        marketplaceCTAs,
        marketplaceMVTDesktopBucket,
        marketplaceMVTMobileBucket
      );
  });

  return navDataWithMarketplaceLink;
};

const addMarketplaceLinkItem = (
  items,
  isUserV2BucketDesktop,
  isUserV2BucketMobile
) => {
  const shopByProduct = items.find(
    ({ label }) => label.toLowerCase() === SHOP_BY_PRODUCT_LABEL
  );

  if (shopByProduct) {
    const variants = populateVariantsArray(
      isUserV2BucketDesktop,
      isUserV2BucketMobile
    );
    const gender = shopByProduct.gender;
    const fullTextGender = gender === "WW" ? "women" : "men";
    const MARKETPLACE_LINK_ID = "marketplaceLink";
    const marketplaceLink = {
      alias: gender,
      id: MARKETPLACE_LINK_ID,
      items: [],
      excludes: [],
      gender,
      label: "Vintage - Marketplace.ASOS.com",
      labelPath: [
        null,
        fullTextGender,
        "Categories",
        "Clothing",
        "SHOP by product",
        "Vintage - Marketplace.ASOS.com"
      ],
      type: "link",
      link: `https://marketplace.asos.com/${fullTextGender}/just-in?tab=boutique&f:condition=12109&ctaref=mktp|${fullTextGender}|nav|justin|vintage&nlid=${variants.join(
        "|"
      )}_${gender}NewVariant`,
      linkType: "external",
      smallAndMediumImageUrl: `https://content.asos-media.com/-/media/Images/Target/2020/MVT/navigation_vintage_${
        gender === "MW" ? "man" : "woman"
      }.jpg`,
      smallAndMediumLayout: undefined,
      smallAndMediumStyleType: "premium",
      smallAndMediumTemplateId: undefined,
      largeScreenColumnSpan: undefined,
      largeScreenImageUrl: undefined,
      largeScreenPriority: 0,
      largeScreenStyleType: "premium",
      largeScreenTemplateId: undefined,
      subtitle: null
    };

    const marketplaceLinkExists = shopByProduct.items.some(
      ({ id }) => id === MARKETPLACE_LINK_ID
    );

    if (!marketplaceLinkExists) {
      shopByProduct.items.push(marketplaceLink);
    }
  }
};

const populateVariantsArray = (isUserV2BucketDesktop, isUserV2BucketMobile) => {
  const variants = [];

  if (isUserV2BucketDesktop) variants.push("EMF95_v2");
  if (isUserV2BucketMobile) variants.push("EMF137_v2");

  return variants;
};

const addMarketplaceMVTFlag = (
  marketplaceItem,
  desktopMVTBucket,
  mobileMVTBucket
) => {
  marketplaceItem.items.forEach(
    item =>
      (item.marketplaceMVTBucket = {
        desktop: desktopMVTBucket,
        mobile: mobileMVTBucket
      })
  );
};

export default handleAddMarketplaceLink;
